import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { login } from '../../services/auth';
import theme from '../../theme';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setUser } = useContext(AuthContext);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = await login(username, password);
      setUser(token);
      if (!!token) {
        history.push('/dashboard');
      }
      else {
        setError('Invalid username or password');
      }
    } catch (err) {
      setError('Invalid username or password');
    }
  };

  return (
    <div className="max-w-md mx-auto mt-12">
      <h2 className={`text-2xl font-bold mb-4 ${theme.textPrimary}`}>Login</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="username" className={`block mb-1 text-sm font-medium ${theme.textSecondary}`}>Username</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className={`w-full px-3 py-2 text-sm ${theme.input}`}
            required
          />
        </div>
        <div>
          <label htmlFor="password" className={`block mb-1 text-sm font-medium ${theme.textSecondary}`}>Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`w-full px-3 py-2 text-sm ${theme.input}`}
            required
          />
        </div>
        <button type="submit" className={`w-full py-2.5 rounded-xl text-sm font-semibold ${theme.btnPrimary}`}>
          Login
        </button>
      </form>
    </div>
  );
}

export default Login;